import allCountries from 'country-region-data'

/**
 * Gets the country name from an ISO 3166-1 alpha-2 country code
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g., 'US', 'AU', 'GB')
 * @returns {string|null} Full country name or null if not found
 * @example
 * getCountryName('US') // 'United States'
 * getCountryName('AU') // 'Australia'
 * getCountryName('XX') // null
 */
export const getCountryName = (countryCode) => {
    const country = allCountries.find((c) => c.countryShortCode === countryCode?.toUpperCase())
    return country?.countryName ?? null
}

/**
 * Gets the state/region name from country and state codes
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code
 * @param {string} stateCode - State/region short code (varies by country)
 * @returns {string|null} Full state/region name or null if not found
 * @example
 * getStateName('US', 'CA') // 'California'
 * getStateName('AU', 'NSW') // 'New South Wales'
 * getStateName('US', 'XX') // null
 */
export const getStateName = (countryCode, stateCode) => {
    const country = allCountries.find((c) => c.countryShortCode === countryCode?.toUpperCase())
    const state = country?.regions.find((region) => region.shortCode === stateCode)
    return state?.name ?? null
}

/**
 * Gets the full list of countries from the country-region-data package
 *
 * @returns {Array} Array of country objects with countryName, countryShortCode, and regions
 */
export const getAllCountries = () => allCountries
